var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextileWearing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 27.965,
    viewBox: "0 0 32 27.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "apparel_24dp_FILL0_wght200_GRAD0_opsz24",
    d: "M121.084-790.777l-3.126,1.734a1.351,1.351,0,0,1-1.008.158,1.213,1.213,0,0,1-.78-.635l-2.151-3.765a1.387,1.387,0,0,1-.158-1.025,1.217,1.217,0,0,1,.635-.8L122.8-800h2.117a1.06,1.06,0,0,1,.785.291,1.061,1.061,0,0,1,.291.785v.336a3.678,3.678,0,0,0,1.144,2.687,3.678,3.678,0,0,0,2.687,1.144,3.678,3.678,0,0,0,2.687-1.144,3.678,3.678,0,0,0,1.144-2.687v-.336a1.061,1.061,0,0,1,.291-.785,1.06,1.06,0,0,1,.785-.291h2.117l8.3,4.894a1.217,1.217,0,0,1,.635.8,1.387,1.387,0,0,1-.158,1.025l-2.151,3.765a1.2,1.2,0,0,1-.775.63,1.39,1.39,0,0,1-1.013-.163l-3.126-1.714v17.387a1.3,1.3,0,0,1-.385.96,1.3,1.3,0,0,1-.96.385H122.428a1.3,1.3,0,0,1-.96-.385,1.3,1.3,0,0,1-.385-.96Zm1.748-2.931v19.925h13.982v-19.925l5.351,2.938,1.768-3.025-7.482-4.437h-1.109a5.527,5.527,0,0,1-1.712,3.709,5.264,5.264,0,0,1-3.807,1.514,5.264,5.264,0,0,1-3.807-1.514,5.527,5.527,0,0,1-1.712-3.709h-1.109l-7.482,4.437,1.768,3.025ZM129.823-786.008Z",
    transform: "translate(-113.823 800)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextileWearing);
export default __webpack_public_path__ + "static/media/textileWearing.4a414a531cbc549cf69b99617f210961.svg";
export { ForwardRef as ReactComponent };